var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload"},[_c('input',{ref:"file",staticClass:"col-sm-12",attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }